import con from '@services/connection'

/**
 * Coletar dados de endereço de acordo com CEP pela API da pagar.me.
 * @param {String} cep CEP, formatado ou somente números.
 * @return {Object} Endereço - Objeto com os dados do endereço.
 *      Exemplo de sucesso:
 *          {"zipcode":"88070740","street":"Avenida Santa Catarina","neighborhood":"Canto","city":"Florianópolis","state":"SC"}
 */
export default async (cep) => {
  if (cep.length >= 8) {
    cep = cep.replace('-', '').replace('.', '')

    const res = await con.post('/v2/api/general/cep/address/get', { cep })

    return res
  }
  return false
}
